import Body from './body'
import Footer from './footer'
import Header from './header'
import './index.css'

export default {
  Body,
  Footer,
  Header
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js